const deferOnload = () =>
    new Promise((resolve) => {
        const throttled = (window.requestIdleCallback || setTimeout).bind(null, resolve);
        /* eslint-disable no-undef */
        if (document.readyState === 'complete') {
            throttled();
        } else {
            window.addEventListener('load', throttled);
        }
        /* eslint-enable no-undef */
    });

export default deferOnload;



/** WEBPACK FOOTER **
 ** ./src/utils/defer-onload.js
 **/